import React from 'react';

const universities = {
  A: ["Auckland University of Technology (AUT)"],
  C: ["University of Canterbury"],
  L: ["Lincoln University"],
  M: ["Massey University"],
  O: ["University of Otago"],
  V: ["Victoria University of Wellington"],
  W: ["University of Waikato", "Whitecliffe College of Arts and Design", "Wellington Institute of Technology"],
  T: ["Toi Ohomai Institute of Technology", "Te Pūkenga (New Zealand Institute of Skills and Technology)"],
  U: ["Unitec Institute of Technology", "Universal College of Learning (UCOL)"],
  E: ["Eastern Institute of Technology (EIT)"],
  S: ["Southern Institute of Technology (SIT)"],
  N: ["NorthTec", "Nelson Marlborough Institute of Technology (NMIT)"],
};

const NewZealandUniversities = () => {
  return (
    <div className="uk-container">
      <h2 className="uk-title">New Zealand Universities</h2>
      <table className="uk-table">
        <thead>
          <tr>
            <th>Letter</th>
            <th>University Name</th>
          </tr>
        </thead>
        <tbody>
          {Object.entries(universities).map(([letter, uniList]) =>
            uniList.map((uni, idx) => (
              <tr key={`${letter}-${idx}`}>
                <td>{idx === 0 ? letter : ''}</td>
                <td>{uni}</td>
              </tr>
            ))
          )}
        </tbody>
      </table>
    </div>
  );
};

export default NewZealandUniversities;
